"use strict";function __export(e){for(var r in e)exports.hasOwnProperty(r)||(exports[r]=e[r])}Object.defineProperty(exports,"__esModule",{value:!0}),__export(require("./BinarySearchTree")),__export(require("./ConsentLanguages")),__export(require("./Fields")),__export(require("./PurposeRestriction")),__export(require("./PurposeRestrictionVector")),__export(require("./DeviceDisclosureStorageAccessType")),__export(require("./RestrictionType")),__export(require("./Segment")),__export(require("./SegmentIDs")),__export(require("./Vector"));


//////////////////
// WEBPACK FOOTER
// ../node_modules/@iabtcf/core/lib/model/index.js
// module id = 1
// module chunks = 0